import routes from 'global/Constants/routes';
import { lazy } from 'react';

const CustomerManagerReport = lazy(() => import('../../pages/dashboard/customerManagerReport/CustomerManagerReport'));
const CustomerOperators = lazy(() => import('../../pages/dashboard/customerManagerReport/CustomerOperators'));

export const customerManagerReportRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.customerOperators.path,
    component: CustomerOperators,
    isPrivate: routes.customerOperators.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.customerManagerReport.path,
    component: CustomerManagerReport,
    isPrivate: routes.customerManagerReport.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
